// extracted by mini-css-extract-plugin
module.exports = {"header":"Header_header__3gkSv","logo":"Header_logo__32LV1","black-bg":"Header_black-bg__2zdw2"};